module.exports = __webpack_public_path__ + "img/rcrf_logo.5a66dadf.jpg";